import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Flex,
  Text,
} from '@shared/components';

export interface QuestionReviewTaskSubmissionErrorModalItem {
  id: string;
  label: string;
}

export interface QuestionReviewTaskSubmissionErrorModalContent {
  title: string;
  description: string;
  items?: readonly QuestionReviewTaskSubmissionErrorModalItem[];
  acknowledgeText?: string;
}

interface QuestionReviewTaskSubmissionErrorModalProps {
  open: boolean;
  onClose: () => void;
  content: QuestionReviewTaskSubmissionErrorModalContent;
}

export function QuestionReviewTaskSubmissionErrorModal(
  props: Readonly<QuestionReviewTaskSubmissionErrorModalProps>,
) {
  const { open, onClose, content } = props;
  const { title, description, items = [], acknowledgeText = 'รับทราบ' } = content;

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs'>
      <DialogTitle onClose={onClose}>{title}</DialogTitle>
      <DialogContent
        sx={(theme) => ({
          px: theme.spacing(6),
          py: theme.spacing(2),
        })}
      >
        <Flex
          sx={{
            flexDirection: 'column',
          }}
        >
          <Text
            variant='body1'
            sx={(theme) => ({
              whiteSpace: 'pre-line',
              color: theme.palette.text.primary,
            })}
          >
            {description}
          </Text>

          {items.length > 0 ? (
            <Flex
              component='ul'
              sx={(theme) => ({
                flexDirection: 'column',
                gap: theme.spacing(2),
                m: 0,
                pl: theme.spacing(6),
              })}
            >
              {items.map((item) => (
                <Text component='li' key={item.id} variant='body1'>
                  {item.label}
                </Text>
              ))}
            </Flex>
          ) : null}
        </Flex>
      </DialogContent>
      <DialogActions
        sx={(theme) => ({
          px: theme.spacing(6),
          justifyContent: 'flex-end',
        })}
      >
        <Button
          onClick={onClose}
          type='button'
          size='large'
          sx={(theme) => ({
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
            '&:hover': {
              backgroundColor: theme.palette.warning.dark,
            },
          })}
        >
          {acknowledgeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
